import memoryStorage from './storage/Memory';

class ClientStore {
  #store: Storage;

  #defaultValue: any;

  constructor(storage: Storage, defaultValue: any = null) {
    this.#defaultValue = defaultValue;
    try {
      storage.setItem('_', '');
      storage.removeItem('_');
      this.#store = storage;
    } catch (_) {
      this.#store = memoryStorage;
    }
  }

  get(key: string, defaultValue?: any) {
    const value = this.#store.getItem(key);
    if (value) {
      return JSON.parse(value);
    }

    if (defaultValue) {
      return defaultValue;
    }

    return this.#defaultValue;
  }

  set(key: string, value: any) {
    this.#store.setItem(key, JSON.stringify(value));
  }

  remove(key: string) {
    this.#store.removeItem(key);
  }
}

export default ClientStore;
